{
    "common": {
        "loading": "Loading…",
        "retry": "Retry",
        "cancel": "Cancel",
        "save": "Save",
        "delete": "Delete",
        "edit": "Edit",
        "close": "Close",
        "closeSidebar": "Close sidebar",
        "open": "Open",
        "activeServerAriaLabel": "Active server: {{name}}. Click to switch.",
        "viewAll": "View all",
        "selectServer": "Select a server",
        "accessDenied": "Access denied",
        "accessDeniedDescription": "You do not have permission to view the {{module}} module for this server.",
        "logout": "Log out",
        "language": "Language",
        "name": "Name",
        "error": "Error",
        "color": "Color",
        "selectServerDesc": "Select a server to continue"
    },
    "linkResult": {
        "spotifyLinked": "Spotify account linked successfully.",
        "lastfmLinked": "Last.fm account linked successfully.",
        "errors": {
            "generic": "Could not link your account. Please try again.",
            "spotify_connect_error": "Could not start the Spotify connection. Please try again.",
            "spotify_exchange_failed": "Could not complete Spotify authorization. Please try again.",
            "spotify_invalid_state": "The Spotify link request expired or was invalid. Please try again.",
            "spotify_missing_code": "Spotify did not return an authorization code. Please try again.",
            "spotify_missing_state": "The Spotify link request was incomplete. Please try again.",
            "spotify_not_configured": "Spotify linking is not configured on this server.",
            "spotify_save_failed": "Spotify was authorized but we could not save the link. Please try again.",
            "lastfm_callback_error": "Last.fm returned an error while linking. Please try again.",
            "lastfm_connect_error": "Could not start the Last.fm connection. Please try again.",
            "lastfm_exchange_failed": "Could not complete Last.fm authorization. Please try again.",
            "lastfm_invalid_state": "The Last.fm link request expired or was invalid. Please try again.",
            "lastfm_missing_state": "The Last.fm link request was incomplete. Please try again.",
            "lastfm_missing_token": "Last.fm did not return an authorization token. Please try again.",
            "lastfm_not_configured": "Last.fm linking is not configured on this server.",
            "lastfm_save_failed": "Last.fm was authorized but we could not save the link. Please try again."
        }
    },
    "languages": {
        "en": "English",
        "pt-BR": "Português (Brasil)"
    },
    "modules": {
        "overview": "overview",
        "settings": "settings",
        "moderation": "moderation",
        "automation": "automation",
        "music": "music",
        "integrations": "integrations"
    },
    "notFound": {
        "title": "Page not found",
        "description": "The page you are looking for does not exist or was moved.",
        "backHome": "Back to home"
    },
    "sidebar": {
        "activeGuild": "Active guild",
        "switchServer": "Switch server",
        "commandCenter": "Command center",
        "status": {
            "selectServer": "Select a server",
            "needsSetup": "Needs setup",
            "ready": "Ready"
        },
        "subtitle": {
            "selectServer": "Choose a community to unlock guild tools.",
            "needsSetup": "Lucky is not installed in this server yet.",
            "ready": "Guild command center is ready for operations."
        },
        "sections": {
            "overview": "Overview",
            "moderation": "Moderation",
            "automation": "Automation",
            "community": "Community",
            "media": "Media",
            "integrations": "Integrations"
        },
        "nav": {
            "dashboard": "Dashboard",
            "serverSettings": "Server Settings",
            "modCases": "Mod Cases",
            "autoModeration": "Auto-Moderation",
            "serverLogs": "Server Logs",
            "autoMessages": "Auto Messages",
            "embedBuilder": "Embed Builder",
            "reactionRoles": "Reaction Roles",
            "roles": "Roles",
            "guildAutomation": "Guild Automation",
            "levelSystem": "Level System",
            "musicPlayer": "Music Player",
            "trackHistory": "Track History",
            "lyrics": "Lyrics",
            "musicalTaste": "Musical Taste",
            "lastFm": "Last.fm",
            "twitch": "Twitch",
            "features": "Features",
            "config": "Configuration",
            "batchJobs": "Batch Jobs",
            "supportReports": "Support Reports",
            "roleGroups": "Role Groups"
        }
    },
    "layout": {
        "routes": {
            "dashboard": {
                "title": "Dashboard",
                "subtitle": "Operational overview and key status signals for your server."
            },
            "servers": {
                "title": "Servers",
                "subtitle": "Review installation status and manage your eligible communities."
            },
            "serverSettings": {
                "title": "Server Settings",
                "subtitle": "Configure bot behaviour, channels, roles, and preferences."
            },
            "moderation": {
                "title": "Mod Cases",
                "subtitle": "Review and manage moderation actions for this server."
            },
            "autoMod": {
                "title": "Auto-Moderation",
                "subtitle": "Configure automated rule enforcement and filters."
            },
            "serverLogs": {
                "title": "Server Logs",
                "subtitle": "Inspect audit events and bot activity records."
            },
            "autoMessages": {
                "title": "Auto Messages",
                "subtitle": "Schedule recurring messages to any channel."
            },
            "embedBuilder": {
                "title": "Embed Builder",
                "subtitle": "Design and send rich Discord embeds."
            },
            "reactionRoles": {
                "title": "Reaction Roles",
                "subtitle": "Assign roles based on member emoji reactions."
            },
            "guildAutomation": {
                "roles": {
                    "title": "Roles",
                    "subtitle": "Manage your server's Discord roles"
                },
                "title": "Guild Automation",
                "subtitle": "Configure automated guild management workflows."
            },
            "levels": {
                "title": "Level System",
                "subtitle": "Configure XP, level roles, and leaderboards."
            },
            "lyrics": {
                "title": "Lyrics",
                "subtitle": "Fetch and display song lyrics in your server."
            },
            "lastFm": {
                "title": "Last.fm",
                "subtitle": "Control account linking and scrobble attribution behavior."
            },
            "twitch": {
                "title": "Twitch Notifications",
                "subtitle": "Post live alerts when tracked streamers go online."
            },
            "features": {
                "title": "Features",
                "subtitle": "Toggle bot feature modules for your server."
            },
            "trackHistory": {
                "title": "Track History",
                "subtitle": "Inspect recent playback and requester activity."
            },
            "music": {
                "title": "Music Player",
                "subtitle": "Manage queue, autoplay, and real-time playback controls."
            },
            "preferredArtists": {
                "title": "Musical Taste",
                "subtitle": "Tune autoplay taste preferences and artist priorities."
            },
            "spotify": {
                "title": "Spotify",
                "subtitle": "Link or unlink Spotify to power autoplay matching."
            },
            "fallback": {
                "title": "Lucky Dashboard",
                "subtitle": "Configure modules, moderation, and engagement workflows."
            },
            "roleGroups": {
                "title": "Role Groups",
                "subtitle": "Create and manage styled role collections."
            }
        }
    },
    "landing": {
        "meta": {
            "title": "Lucky — Free Discord music bot with autoplay & dashboard",
            "description": "Lucky learns your server's taste and keeps the call playing with autoplay, no DJ needed. Free, no paywall."
        },
        "hero": {
            "eyebrow": "Open source · ISC",
            "headlineLine1": "Learns your server's taste.",
            "headlineLine2": "Keeps the call playing.",
            "subtitle": "No DJ needed. Search by name or paste a Spotify link and autoplay picks up from there. Free, no paywall.",
            "ctaPrimary": "Add to Discord"
        },
        "repoCard": {
            "name": "LucasSantana-Dev / Lucky",
            "description": "Discord music bot with taste-learning autoplay and a React dashboard.",
            "license": "ISC",
            "lang": "TypeScript",
            "serversLabel": "servers",
            "usersLabel": "users",
            "viewOnGithub": "View on GitHub",
            "copyClone": "Copy clone URL"
        },
        "commands": {
            "heading": "Music commands, right where you need them",
            "rows": {
                "play": {
                    "name": "/play",
                    "description": "Queue a track by name or paste a Spotify link",
                    "kbd": "music"
                },
                "autoplay": {
                    "name": "/autoplay",
                    "description": "Genre-aware recommendations, won't drift languages",
                    "kbd": "music"
                },
                "queue": {
                    "name": "/queue",
                    "description": "Inspect or reorder the current queue",
                    "kbd": "music"
                },
                "skip": {
                    "name": "/skip",
                    "description": "Skip the current track",
                    "kbd": "music"
                },
                "lyrics": {
                    "name": "/lyrics",
                    "description": "Fetch lyrics for the current track",
                    "kbd": "music"
                },
                "recap": {
                    "name": "/recap",
                    "description": "Weekly digest of what this server listened to",
                    "kbd": "music"
                }
            },
            "more": "+ more commands with /help"
        },
        "stack": {
            "heading": "For developers — what you're running",
            "subheading": "Standard Node + Postgres stack. Nothing exotic. `docker compose up` and you're online. Skip this if you're using the hosted version.",
            "items": {
                "bot": {
                    "name": "lucky-bot",
                    "description": "discord.js client, Lavalink-free audio via yt-dlp + Opus"
                },
                "backend": {
                    "name": "lucky-backend",
                    "description": "Express API, OAuth, Prisma to Postgres"
                },
                "frontend": {
                    "name": "lucky-frontend",
                    "description": "React 19 + Vite + Tailwind, Discord OAuth dashboard"
                },
                "postgres": {
                    "name": "postgres",
                    "description": "Guild config, music history, autoplay state"
                },
                "redis": {
                    "name": "redis",
                    "description": "Session cache, rate-limit buckets, autoplay state"
                },
                "nginx": {
                    "name": "nginx",
                    "description": "Reverse proxy, /webhook → /hooks rewrite for deploy"
                }
            }
        },
        "footerRepo": {
            "heading": "Open source under ISC",
            "subheading": "Fork it, contribute, run it, deploy your own. The code is the spec."
        },
        "footer": {
            "tagline": "Open-source Discord bot. Run it yourself or use the hosted version.",
            "links": "Product",
            "support": "Community",
            "supportCopy": "Issues and PRs welcome on GitHub. Or hop in the Discord support server.",
            "terms": "Terms",
            "privacy": "Privacy",
            "github": "Source code",
            "docs": "Docs",
            "changelog": "Changelog",
            "discord": "Support server",
            "copyright": "© 2026 Lucky. ISC."
        },
        "features": {
            "heading": "What Lucky does",
            "subheading": "Everything most servers need, in one bot. No premium tier paywalling the good parts.",
            "items": {
                "music": {
                    "title": "Music with smart autoplay",
                    "description": "Search by name or paste a Spotify link. Autoplay learns the mood and won't drift into the wrong language."
                },
                "recap": {
                    "title": "Weekly recap, automatically",
                    "description": "Every Sunday, Lucky posts a digest of what the server listened to: top tracks, total plays, and listening time."
                },
                "dashboard": {
                    "title": "A real web dashboard",
                    "description": "Configure everything from your browser. Discord OAuth login, no JSON files, no SSH."
                }
            }
        }
    },
    "login": {
        "meta": {
            "title": "Login - Lucky",
            "description": "Login to Lucky Dashboard to manage your Discord servers"
        },
        "brand": "Discord Bot Dashboard",
        "headline": "Manage your Discord servers",
        "description": "Configure music, autoplay preferences, and bot settings — all in one place.",
        "modules": "Modules",
        "commands": "Commands",
        "uptime": "Uptime",
        "authentication": "Authentication",
        "signInWithDiscord": "Sign in with Discord",
        "permissionsNote": "Your guild permissions and bot controls are tied to your Discord account.",
        "connecting": "Connecting...",
        "loginButton": "Login with Discord",
        "badges": {
            "oauthSecured": "OAuth secured",
            "fastSetup": "Fast setup",
            "liveControls": "Live controls"
        },
        "copyright": "© 2026 Lucky. All rights reserved.",
        "loggedOut": "Logged out successfully",
        "logoutFailed": "Failed to log out",
        "authenticated": "Successfully authenticated!",
        "verifyFailed": "Failed to verify authentication",
        "errors": {
            "auth_failed": "Authentication failed. Please try again.",
            "missing_code": "Missing authorization code. Please try again.",
            "missing_state": "Security validation failed. Please try again.",
            "invalid_state": "Invalid security token. Please try again.",
            "session_failed": "Failed to create session. Please try again.",
            "authentication_error": "An error occurred during authentication. Please try again.",
            "client_id_not_configured": "Authentication service is not properly configured. Please contact support.",
            "redirect_error": "Failed to redirect to authentication service. Please try again.",
            "generic": "An error occurred"
        }
    },
    "support": {
        "title": "Report a problem",
        "subtitle": "Tell us what happened — add a screenshot if you can.",
        "referenceId": "Reference ID",
        "form": {
            "contextLabel": "What happened?",
            "contextPlaceholder": "Describe what you were doing and what went wrong…",
            "imageLabel": "Screenshot (optional)",
            "imageTypeError": "Unsupported image type. Use PNG, JPEG, or WebP.",
            "imageSizeError": "Image is too large (max 5 MB).",
            "submit": "Send report",
            "genericError": "Failed to submit your report. Please try again."
        },
        "success": {
            "title": "Thanks for the report",
            "body": "We received it and will look into it."
        },
        "admin": {
            "title": "Support reports",
            "subtitle": "User-submitted bug reports.",
            "loadError": "Could not load reports.",
            "emptyTitle": "No reports",
            "emptyDescription": "No support reports match this filter.",
            "selectPrompt": "Select a report to view details.",
            "hasImage": "Has screenshot",
            "imageAlt": "Report screenshot",
            "status": {
                "all": "All",
                "new": "New",
                "triaged": "Triaged",
                "promoted": "Promoted",
                "dismissed": "Dismissed"
            }
        }
    },
    "roles": {
        "title": "Roles",
        "subtitle": "Manage your server's Discord roles",
        "createRole": "Create Role",
        "noRoles": "No roles found",
        "noRolesDesc": "Create your first role to get started",
        "deleteConfirm": "Are you sure you want to delete this role?",
        "deleteConfirmDesc": "Are you sure you want to delete",
        "bulkDeleteConfirm": "Delete {{count}} roles?",
        "bulkDeleteConfirmDesc": "This will permanently delete",
        "managed": "Managed",
        "hoist": "Hoist",
        "mentionable": "Mentionable",
        "editRole": "Edit Role",
        "duplicated": "Role duplicated",
        "deleted": "Role deleted",
        "bulkDeleted": "{{count}} roles deleted",
        "created": "Role created",
        "updated": "Role updated",
        "failedToLoad": "Failed to load roles",
        "failedToCreate": "Failed to create role",
        "failedToUpdate": "Failed to update role",
        "failedToDelete": "Failed to delete role",
        "failedToDuplicate": "Failed to duplicate role",
        "bulkDeleteFailed": "Failed to delete {{count}} roles",
        "selectedCount": "{{count}} roles selected",
        "delete": "Delete",
        "roles": "roles"
    },
    "admin": {
        "adminPanel": "Admin Panel",
        "signInWithDiscord": "Sign in with Discord to access the admin panel.",
        "accessDenied": "Access Denied",
        "accessDeniedDesc": "This page is restricted to bot administrators.",
        "globalFeatureToggles": "Global Feature Toggles",
        "manageFeatureFlags": "Manage feature flags across all servers",
        "serverManagement": "Server Management",
        "viewAndManageBotActivity": "View and manage bot activity across all servers"
    },
    "autoMessages": {
        "title": "Auto Messages",
        "subtitle": "Schedule automatic messages for {{name}}",
        "editAutoMessage": "Edit Auto Message",
        "newAutoMessage": "New Auto Message",
        "type": "Type",
        "typeWelcome": "Welcome",
        "typeLeave": "Leave",
        "typeAutoResponse": "Auto Response",
        "channelId": "Channel ID",
        "channelIdPlaceholder": "Discord channel ID",
        "message": "Message",
        "messagePlaceholder": "Message content...",
        "trigger": "Trigger",
        "triggerPlaceholder": "Word or phrase that triggers this response",
        "exactMatch": "Exact match only",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "cancel": "Cancel",
        "saving": "Saving…",
        "save": "Save",
        "saveError": "Failed to save auto message",
        "deleteError": "Failed to delete auto message",
        "noServerSelected": "No Server Selected",
        "selectServerToManage": "Select a server to manage auto messages",
        "noAutoMessagesConfigured": "No auto messages configured",
        "createScheduledMessages": "Create scheduled messages that are posted automatically to your server",
        "editAriaLabel": "Edit {{type}} message",
        "deleteAriaLabel": "Delete {{type}} message",
        "deleteMessage": "Delete Auto Message",
        "deleteMessageConfirm": "Are you sure you want to delete this {{type}} message? This cannot be undone.",
        "delete": "Delete",
        "createAutoMessage": "Create Auto Message",
        "newMessage": "New Message"
    },
    "autoMod": {
        "title": "Auto-Moderation",
        "subtitle": "Configure automatic content filters for {{name}}",
        "saveChanges": "Save Changes",
        "templates": "Templates",
        "startFromCurated": "Start from curated defaults for spam protection.",
        "noTemplatesAvailable": "No templates available right now.",
        "contentFilters": "Content Filters",
        "spamDetection": "Spam Detection",
        "detectAndActOnSpam": "Detect and act on message spam",
        "maxMessages": "Max messages",
        "timeWindow": "Time window (s)",
        "exemptions": "Exemptions",
        "channelsAndRolesExempt": "Channels and roles exempt from auto-moderation filters",
        "exemptChannels": "Exempt Channels",
        "selectChannelPlaceholder": "Select a channel...",
        "exemptRoles": "Exempt Roles",
        "selectRolePlaceholder": "Select a role...",
        "channelsUnavailable": "Channels unavailable, enter IDs manually below",
        "rolesUnavailable": "Roles unavailable, enter IDs manually below",
        "channelIdPlaceholder": "Channel ID...",
        "roleIdPlaceholder": "Role ID...",
        "failedToLoadSettings": "Failed to load automod settings. Saving is disabled until settings load successfully.",
        "failedToLoadTemplates": "Failed to load templates",
        "failedToLoadChannels": "Failed to load Discord channels",
        "failedToLoadRoles": "Failed to load Discord roles",
        "settingsSaved": "Auto-moderation settings saved!",
        "failedToSave": "Failed to save settings",
        "templateApplied": "Auto-moderation template applied",
        "failedToApplyTemplate": "Failed to apply template",
        "applyTemplate": "Apply template",
        "applyTemplateAria": "Apply {{name}} template",
        "applyingTemplateAria": "Applying {{name}} template",
        "noServerSelected": "No Server Selected",
        "selectServerToConfigure": "Select a server to configure auto-moderation"
    },
    "config": {
        "configuration": "Configuration",
        "selectServerToConfigure": "Please select a server to configure",
        "server": "Server:",
        "availableConfigurationModules": "Available Configuration Modules",
        "musicModule": "Music Module",
        "configureMusic": "Configure music playback, queue management, and audio settings",
        "moderation": "Moderation",
        "setupAutoModeration": "Set up auto-moderation, filters, and moderation actions",
        "back": "Back",
        "pageTitle": "Configuration - Lucky",
        "pageDescription": "Configure modules and commands for your Discord servers"
    },
    "dashboard": {
        "noServerSelected": "No Server Selected",
        "selectServerFromSidebar": "Select a server from the sidebar to manage it",
        "viewYourServers": "View Your Servers",
        "pageTitle": "Dashboard"
    },
    "dashboardOverview": {
        "selectAServer": "Select a Server",
        "chooseServerFromSidebar": "Choose a server from the sidebar to view its dashboard",
        "dashboardTitle": "Dashboard",
        "serverAnalytics": "Server analytics",
        "overviewOf": "Overview of {{name}}",
        "totalMembers": "Total Members",
        "activeMembersAcross": "Active members across {{name}}",
        "activeCases": "Active Cases",
        "totalCases": "Total Cases",
        "autoModActions": "Auto-Mod Actions",
        "recentCases": "Recent Cases",
        "latestModerationActions": "Latest moderation actions",
        "viewAll": "View all",
        "noModerationCases": "No moderation cases yet",
        "casesCasesWillAppear": "Cases will appear here when moderators take action",
        "quickActions": "Quick Actions",
        "moderationCases": "Moderation Cases",
        "reviewWarningsMutesKicksBans": "Review warnings, mutes, kicks, and bans.",
        "autoModeration": "Auto-Moderation",
        "tuneFiltersAntiSpamAutomation": "Tune filters and anti-spam automation.",
        "serverLogs": "Server Logs",
        "auditEventsAndModerationActivity": "Audit events and moderation activity.",
        "musicPlayer": "Music Player",
        "viewQueuePlaybackTrackHistory": "View queue, playback, and track history.",
        "levelsAndXP": "Levels & XP",
        "configureXPLevelRewardsLeaderboards": "Configure XP, level rewards, and leaderboards.",
        "recentMusic": "Recent Music",
        "latestTracksPlayed": "Latest tracks played",
        "lastPlayed": "Last played",
        "unknownListener": "Unknown",
        "noTracksPlayedYet": "No tracks played yet",
        "trackHistoryWillAppearWhenMusicPlayed": "Track history will appear here when music is played",
        "community": "Community",
        "levelLeaderboard": "Level Leaderboard",
        "topMembersByXP": "Top members by XP",
        "noLeaderboardData": "No leaderboard data",
        "casesByType": "Cases by Type"
    },
    "embedBuilder": {
        "pageTitle": "Embed Builder",
        "pageDescription": "Create and manage reusable Discord embed templates",
        "newTemplate": "New Template",
        "fields": "Fields",
        "addField": "Add Field",
        "fieldName": "Field name",
        "fieldValue": "Field value",
        "inline": "Inline",
        "removeFieldAriaLabel": "Remove field {{index}}",
        "editEmbedTemplate": "Edit Embed Template",
        "newEmbedTemplate": "New Embed Template",
        "cancel": "Cancel",
        "saveChanges": "Save Changes",
        "createTemplate": "Create Template",
        "templateName": "Template Name *",
        "templateNamePlaceholder": "e.g. welcome-message",
        "color": "Color",
        "title": "Title",
        "titlePlaceholder": "Embed title",
        "description": "Description",
        "descriptionPlaceholder": "Embed description (supports markdown)",
        "thumbnailUrl": "Thumbnail URL",
        "thumbnailAlt": "embed thumbnail",
        "imageUrl": "Image URL",
        "urlPlaceholder": "https://...",
        "footer": "Footer",
        "footerPlaceholder": "Footer text",
        "preview": "Preview",
        "fillFieldsToSeePreview": "Fill in the fields to see a preview",
        "saving": "Saving...",
        "noEmbedTemplates": "No embed templates",
        "createFirstEmbedTemplate": "Create your first embed template to use in bot commands",
        "editAriaLabel": "Edit {{name}}",
        "deleteAriaLabel": "Delete {{name}}",
        "deleteTemplate": "Delete Template",
        "deleteTemplateConfirm": "Delete \"{{name}}\"? This cannot be undone.",
        "delete": "Delete",
        "used": "Used {{count}}×",
        "field": "field",
        "fields_plural": "fields"
    },
    "guildAutomation": {
        "pageTitle": "Guild Automation",
        "pageDescription": "Manage your guild configuration as code — plan, apply, and track changes.",
        "noServerSelected": "No server selected",
        "selectServerToManage": "Select a server to manage Guild Automation.",
        "loadErrorMessage": "Couldn't load automation status or manifest — the API may be unavailable.",
        "retry": "Retry",
        "automationStatus": "Automation Status",
        "refreshStatusTitle": "Refresh status",
        "plan": "Plan",
        "recordPlan": "Record Plan",
        "reconcile": "Reconcile",
        "planResult": "Plan Result",
        "planRecord": "Plan Record",
        "manifest": "Manifest",
        "noManifestFound": "No manifest found. Paste or write a manifest below to get started.",
        "manifestPlaceholder": "{ \"guildId\": \"...\", \"version\": \"1\", \"roles\": {}, \"channels\": {} }",
        "saveManifest": "Save Manifest",
        "runHistory": "Run History",
        "noRunsYet": "No runs yet",
        "runPlanOrApply": "Run a plan or apply to see results here.",
        "invalidJsonError": "Invalid JSON — please fix syntax errors before saving.",
        "noChangesDetected": "No changes detected.",
        "appliedCount_one": "{{count}} applied",
        "appliedCount_other": "{{count}} applied",
        "failedCount_one": "{{count}} failed",
        "failedCount_other": "{{count}} failed",
        "manifestSaved": "Manifest saved successfully.",
        "manifestSaveFailed": "Failed to save manifest.",
        "planGenerated": "Plan generated.",
        "planFailed": "Failed to generate plan.",
        "planRecorded": "Plan recorded. Apply changes using /guildconfig apply in Discord.",
        "planRecordFailed": "Failed to record plan.",
        "reconcileRecorded": "Drift reconciliation recorded. Apply changes using /guildconfig reconcile in Discord.",
        "reconcileFailed": "Failed to record reconciliation.",
        "expandManifest": "Expand"
    },
    "lastFm": {
        "musicIdentityEyebrow": "Music identity",
        "pageTitle": "Last.fm",
        "pageDescription": "Scrobble tracks you play to your Last.fm profile",
        "notConfigured": "Not Configured",
        "lastFmNotConfigured": "Last.fm integration is not configured. Ask the server owner to set:",
        "lastFmApiKey": "LASTFM_API_KEY",
        "lastFmApiSecret": "LASTFM_API_SECRET",
        "connected": "Connected",
        "linkedAs": "Linked as",
        "active": "Active",
        "connectionDescription": "Tracks you request via the bot will be scrobbled to your Last.fm profile automatically.",
        "disconnect": "Disconnect",
        "connectYourAccount": "Connect Your Account",
        "connectAccountDescription": "Link your Last.fm account so tracks you play through the bot are automatically scrobbled to your profile.",
        "connectWithLastFm": "Connect with Last.fm",
        "scrobbleCoverage": "Scrobble coverage",
        "scrobbleCoverageDescription": "Lucky tracks requested songs and forwards play activity once linked.",
        "privacyControl": "Privacy control",
        "privacyControlDescription": "Disconnect anytime without affecting server playback.",
        "howItWorks": "How it works",
        "step1": "Connect your Last.fm account above",
        "step2": "Play music in a voice channel using the bot",
        "step3": "Tracks are automatically scrobbled to your profile",
        "step4": "External music bots (Rythm, Groovy, etc.) are also detected",
        "failedToLoadStatus": "Failed to load Last.fm status",
        "failedToUnlink": "Failed to unlink account",
        "disconnectConfirm": "Disconnect your Last.fm account?"
    },
    "levels": {
        "noServerSelected": "No server selected",
        "selectServerToView": "Select a server to view level settings",
        "leaderboard": "Leaderboard",
        "noDataYet": "No data yet",
        "membersGainXp": "Members gain XP by chatting once the level system is enabled",
        "level": "Level",
        "xp": "XP",
        "settings": "Settings",
        "enableXp": "Enable XP",
        "xpPerMessage": "XP Per Message",
        "cooldown": "Cooldown (ms)",
        "announceChannel": "Announce Channel",
        "channelIdOptional": "Channel ID (optional)",
        "saveSettings": "Save Settings",
        "saving": "Saving...",
        "levelRewards": "Level Rewards",
        "couldNotLoadRoles": "Couldn't load this server's roles — reward role names may show as raw IDs. Refresh to retry.",
        "noRewardsConfigured": "No rewards configured",
        "levelLabel": "Level",
        "roleIdLabel": "Role ID",
        "addReward": "Add Reward",
        "adding": "Adding...",
        "levelSettingsSaved": "Level settings saved",
        "failedToSaveSettings": "Failed to save settings",
        "rewardAdded": "Reward added for level {{level}}",
        "failedToAddReward": "Failed to add reward",
        "rewardRemoved": "Reward removed",
        "failedToRemoveReward": "Failed to remove reward",
        "levelPlaceholder": "e.g. 5",
        "roleIdPlaceholder": "Role ID",
        "selectRole": "Select a role",
        "deletedRole": "Deleted role ({{id}})",
        "failedToLoadSettings": "Failed to load level settings"
    },
    "lyrics": {
        "noServerSelected": "No Server Selected",
        "selectServerToSearch": "Select a server to search lyrics",
        "lyricsSearch": "Lyrics Search",
        "songTitle": "Song Title",
        "required": "*",
        "enterSongTitle": "Enter song title",
        "artist": "Artist (optional)",
        "enterArtistName": "Enter artist name",
        "search": "Search",
        "searching": "Searching...",
        "failedToFetchLyrics": "Failed to fetch lyrics. Please try again.",
        "noLyricsFound": "No lyrics found",
        "noLyricsFoundDescription": "Try a different title or check the spelling.",
        "findLyricsTitle": "Find lyrics for any track",
        "searchForLyrics": "Search for lyrics by entering a song title"
    },
    "moderation": {
        "noServerSelected": "No Server Selected",
        "selectServerToViewCases": "Select a server to view moderation cases",
        "moderationCases": "Moderation Cases",
        "manageWarningsAndBans": "Manage warnings, mutes, kicks, and bans",
        "totalCases": "Total Cases",
        "activeCases": "Active Cases",
        "warnings": "Warnings",
        "bans": "Bans",
        "searchByUserModeratorOrReason": "Search by user, moderator, or reason...",
        "allTypes": "All types",
        "mutes": "Mutes",
        "kicks": "Kicks",
        "unbans": "Unbans",
        "unmutes": "Unmutes",
        "tableHeaderCase": "#",
        "tableHeaderUser": "User",
        "tableHeaderModerator": "Moderator",
        "tableHeaderType": "Type",
        "tableHeaderStatus": "Status",
        "tableHeaderDate": "Date",
        "noCasesFound": "No cases found",
        "tryAdjustingFilters": "Try adjusting your filters",
        "moderationCasesWillAppearHere": "Moderation cases will appear here",
        "showingToOf": "Showing {{from}} to {{to}} of {{total}}",
        "caseDetailTitle": "Case #{{number}}",
        "caseUser": "User",
        "caseModerator": "Moderator",
        "caseAction": "Action",
        "caseDate": "Date",
        "caseReason": "Reason",
        "caseDuration": "Duration",
        "durationMinutes": "Duration: {{minutes}} minutes",
        "noReasonProvided": "No reason provided",
        "active": "Active",
        "expired": "Expired",
        "appealed": "Appealed",
        "deactivateCase": "Deactivate Case",
        "deactivating": "Deactivating...",
        "caseDeactivated": "Case deactivated",
        "failedToDeactivateCase": "Failed to deactivate case",
        "settingsTitle": "Moderation settings",
        "settingsLogChannel": "Log channel",
        "settingsMuteRole": "Mute role",
        "settingsModRoles": "Moderator roles",
        "settingsMaxWarnings": "Warnings before action",
        "settingsDmOnAction": "Message members when moderated",
        "settingsNone": "None",
        "settingsSave": "Save settings",
        "settingsSaving": "Saving...",
        "settingsSaved": "Settings saved",
        "settingsLoadFailed": "Failed to load settings",
        "settingsSaveFailed": "Failed to save settings",
        "settingsChannelsFailed": "Failed to load channels",
        "settingsRolesFailed": "Failed to load roles",
        "settingsRetry": "Retry",
        "settingsModRolesLimit": "Up to {{max}} moderator roles",
        "justNow": "Just now",
        "minutesAgo": "{{minutes}}m ago",
        "hoursAgo": "{{hours}}h ago",
        "daysAgo": "{{days}}d ago"
    },
    "music": {
        "noServerSelected": "No Server Selected",
        "selectServerToControlMusic": "Select a server to control music playback",
        "musicPlayer": "Music Player",
        "connectedToVoiceChannel": "Connected to {{channel}}",
        "notConnectedToVoiceChannel": "Not connected to a voice channel",
        "connected": "Live",
        "reconnecting": "Reconnecting",
        "connectedToLiveUpdates": "Connected to live updates",
        "reconnectingToLiveUpdates": "Reconnecting to live updates",
        "nowPlaying": "Now Playing",
        "unknown": "Unknown",
        "nothingPlaying": "Nothing playing",
        "searchOrImportToGetStarted": "Start playback from Discord with /play, or search and import below.",
        "searchDescription": "Search for a song or paste a link",
        "importDescription": "Import a playlist by pasting a link",
        "queue": "Queue",
        "volume": "Volume",
        "shuffle": "Shuffle",
        "previousTrack": "Previous track",
        "play": "Play",
        "pause": "Pause",
        "nextTrack": "Next track",
        "repeatMode": "Repeat: {{mode}}",
        "progressMayBeOutdated": "may be outdated",
        "commandInProgress": "Working on that command…",
        "dismissError": "Dismiss",
        "playerNotConnected": "Player is not connected",
        "viewDiscussion": "View discussion on Discord",
        "autoplayAcceptance": "Autoplay acceptance",
        "timeWindow": "Time window",
        "tableHeaderSource": "Source",
        "tableHeaderCandidates": "Candidates",
        "tableHeaderAccepted": "Accepted",
        "tableHeaderRate": "Rate",
        "autoplayLoading": "Loading…",
        "autoplayLoadFailed": "Failed to load autoplay acceptance data.",
        "noAutoplayHistoryTitle": "No autoplay history yet",
        "noAutoplayHistoryDescription": "No recommendations were recorded for this server in the last {{days}} days.",
        "autoplayOverallSummary": "{{accepted}} of {{total}} picks accepted overall ({{rate}}) in the last {{days}} days."
    },
    "preferredArtists": {
        "noServerSelected": "No Server Selected",
        "selectServerToManageArtists": "Select a server to manage preferred artists",
        "musicPersonalization": "Music personalization",
        "musicalTaste": "Musical Taste",
        "chooseArtistsDescription": "Choose artists to guide autoplay recommendations. When multiple people are in voice, Lucky blends everyone's preferences.",
        "discoverTab": "Discover",
        "preferredTab": "Preferred",
        "blockedTab": "Blocked",
        "searchForArtist": "Search for an artist...",
        "searching": "Searching...",
        "failedToSearchArtists": "Failed to search artists",
        "noArtistsFound": "No artists found for \"{{query}}\"",
        "noSuggestionsAvailable": "No suggestions available. Try searching for artists above.",
        "noPreferredArtistsYet": "No preferred artists yet",
        "addFromDiscover": "Add some from Discover.",
        "noBlockedArtists": "No blocked artists",
        "blockArtistsDescription": "Block artists you don't want Lucky to autoplay.",
        "preferArtist": "Prefer",
        "blockArtist": "Block",
        "savePreferences": "Save Preferences ({{count}})",
        "saving": "Saving...",
        "prefer": "Prefer",
        "block": "Block"
    },
    "reactionRoles": {
        "title": "Title",
        "description": "Description",
        "export": "Export",
        "import": "Import",
        "create": "Create",
        "noMessagesTitle": "No reaction role messages",
        "noMessagesDescription": "Create your first reaction role message to let members self-assign roles with buttons.",
        "noServerSelected": "No server selected",
        "selectServerDescription": "Select a server from the sidebar to view reaction roles.",
        "createTitle": "Create Reaction Role Message",
        "editTitle": "Edit Reaction Role Message",
        "channel": "Channel",
        "selectChannelPlaceholder": "Select a channel",
        "channelCannotChange": "Channel cannot be changed on edit",
        "titlePlaceholder": "e.g. Pick your roles",
        "descriptionPlaceholder": "Explain how to use the buttons below…",
        "imageUrlOptional": "Image URL (optional)",
        "imageUrlPlaceholder": "https://example.com/image.png",
        "uploadImageOptional": "Upload Image (optional)",
        "chooseImage": "Choose Image",
        "roles": "Roles",
        "addRole": "Add role",
        "role": "Role",
        "selectRolePlaceholder": "Select role",
        "roleAboveBot": "This role is at or above the bot's highest role. Discord will reject it; move the bot role higher in server settings.",
        "aboveBotSuffix": "(at or above bot)",
        "buttonLabel": "Button label",
        "buttonLabelPlaceholder": "Label",
        "emojiOptional": "Emoji (optional)",
        "style": "Style",
        "cancel": "Cancel",
        "submit": "Create",
        "submitUpdating": "Updating…",
        "submitCreating": "Creating…",
        "submitUpdate": "Update",
        "selectChannelError": "Select a channel",
        "titleRequiredError": "Title is required",
        "descriptionRequiredError": "Description is required",
        "addRoleError": "Add at least one role with a label",
        "createFailedError": "Failed to create reaction role message",
        "updateFailedError": "Failed to update reaction role message",
        "deleteFailedError": "Failed to delete reaction role message.",
        "loadFailedError": "Failed to load reaction role messages.",
        "noMappings": "No role mappings found for this message.",
        "createRoleGroup": "Create role group",
        "createRoleGroupTitle": "Create a role group to manage styled roles",
        "addStyledRole": "Add styled role",
        "defaultRoleGroupName": "Role Group {{timestamp}}",
        "createRoleGroupError": "Failed to create role group."
    },
    "serverLogs": {
        "title": "Server Logs",
        "subtitle": "Activity and moderation logs for {{name}}",
        "export": "Export",
        "searchAndFilter": "Search & Filter",
        "searchPlaceholder": "Search logs…",
        "allLevels": "All levels",
        "info": "Info",
        "warnings": "Warnings",
        "errors": "Errors",
        "moderation": "Moderation",
        "autoMod": "Auto-Mod",
        "system": "System",
        "noServerSelected": "No Server Selected",
        "selectServerDescription": "Select a server to view logs",
        "noLogsFound": "No logs found",
        "adjustFilters": "Try adjusting your filters",
        "logsWillAppear": "Logs will appear here as events occur",
        "exportSuccess": "Logs exported!",
        "loadError": "Failed to load logs. Please try again.",
        "userLabel": "User:",
        "channelLabel": "Channel:",
        "loggingToggle": "Record server activity",
        "loggingToggleDescription": "Off by default. When on, Lucky stores for this server: member joins and leaves, deleted and edited messages (up to 500 characters of text), bans and unbans with their reasons, and channel and role changes.",
        "loggingToggleError": "Could not update logging. Please try again.",
        "loggingSettingsLoadError": "Could not load the logging setting. Reload the page to try again."
    },
    "serverSettings": {
        "title": "Server Settings",
        "description": "General configuration for {{name}}",
        "eyebrow": "Configuration",
        "saveChanges": "Save Changes",
        "viewOnlyNotice": "You have view-only access to these settings. Changes cannot be saved.",
        "saving": "Saving…",
        "noServerSelected": "No Server Selected",
        "selectServerDescription": "Select a server to manage settings",
        "unableToLoadTitle": "Unable to load server settings",
        "retryButtonLabel": "Retry",
        "reAuthenticateLink": "Re-authenticate",
        "sessionExpired": "Session expired. Please sign in again.",
        "accessDenied": "You no longer have access to this server settings.",
        "networkError": "Unable to reach API. Check your connection and retry.",
        "general": "General",
        "commandPrefix": "Command Prefix",
        "commandPrefixPlaceholder": "!",
        "embedColor": "Embed Color",
        "embedColorPlaceholder": "0x5865F2",
        "language": "Language",
        "musicDefaults": "Music Defaults",
        "defaultVolume": "Default Volume",
        "maxQueueSize": "Max Queue Size",
        "commandCooldown": "Command Cooldown (seconds)",
        "voteSkipThreshold": "Vote Skip Threshold (%)",
        "allowPlaylists": "Allow Playlists",
        "allowPlaylistsDescription": "Let members queue full playlists, not just single tracks",
        "allowSpotify": "Allow Spotify",
        "allowSpotifyDescription": "Let members queue tracks from Spotify links",
        "accessControl": "Access Control",
        "accessControlDescription": "Assign role-based web dashboard permissions",
        "addRuleLabel": "Add Rule",
        "saveAccessControl": "Save Policy",
        "rbacCannotManage": "Only server owner or users with Administrator/Manage Server permission can manage RBAC policy.",
        "noRbacRules": "No RBAC rules configured. Add a rule to grant module access.",
        "noAssignableRoles": "No assignable roles found for this server yet.",
        "retryRoles": "Retry Roles",
        "roleSelectPlaceholder": "Role",
        "moduleSelectPlaceholder": "Module",
        "modeSelectPlaceholder": "Mode",
        "modeView": "view",
        "modeManage": "manage",
        "removeRuleTitle": "Remove rule",
        "settingsSaved": "Server settings saved!",
        "settingsSaveFailed": "Failed to save settings",
        "accessControlSaved": "Access control policy saved",
        "accessControlFailed": "Failed to save access control policy",
        "stillLoadingRoles": "Still loading role options. Try again in a moment.",
        "roleOptionsNotAvailable": "Role options are not available yet. Retry loading roles.",
        "unableToLoadMessage": "Failed to load server settings."
    },
    "servers": {
        "discordAccount": "Discord Account",
        "totalServers": "Total Servers",
        "serversLabel": "Servers",
        "yourServers": "Your Servers",
        "serversWithBot": "{{count}} servers — {{count2}} with Lucky installed",
        "navServers": "Servers",
        "navPremium": "Premium",
        "navSettings": "Settings",
        "recentlyActive": "Recently Active",
        "allOtherServers": "All Other Servers",
        "luckyInstalled": "Lucky installed",
        "inviteLucky": "Invite Lucky",
        "noServersTitle": "No servers yet",
        "noServersDescription": "Join a Discord server and Lucky will appear here."
    },
    "spotify": {
        "eyebrow": "Music personalization",
        "title": "Spotify",
        "description": "Connect your Spotify account for personalized autoplay recommendations",
        "notConfigured": "Not Configured",
        "notConfiguredDesc": "Spotify integration is not configured. Ask the server owner to set:",
        "clientIdEnv": "SPOTIFY_CLIENT_ID",
        "clientSecretEnv": "SPOTIFY_CLIENT_SECRET",
        "connected": "Connected",
        "linkedAs": "Linked as",
        "active": "Active",
        "accessExplanation": "Lucky can access your library and listening history to provide personalized autoplay recommendations.",
        "disconnect": "Disconnect",
        "connectYourAccount": "Connect Your Account",
        "connectDescription": "Link your Spotify account so Lucky can learn your music preferences and provide personalized autoplay recommendations.",
        "connectWithSpotify": "Connect with Spotify",
        "smarterAutoplay": "Smarter autoplay",
        "smarterAutoplayDesc": "Lucky learns from your library, top tracks, and recent listening.",
        "privacyControl": "Privacy control",
        "privacyControlDesc": "Disconnect anytime without affecting server playback.",
        "howItWorks": "How it works",
        "step1": "Connect your Spotify account above",
        "step2": "Lucky accesses your library, top tracks, and recent listening",
        "step3": "When autoplay is active, Lucky recommends similar tracks based on your preferences",
        "step4": "Your library stays private and is only used for recommendations",
        "failedToLoadStatus": "Failed to load Spotify status",
        "failedToUnlink": "Failed to unlink account",
        "confirmDisconnect": "Disconnect your Spotify account?"
    },
    "trackHistory": {
        "noServerSelected": "No Server Selected",
        "selectServerToViewHistory": "Select a server to view track history",
        "trackHistory": "Track History",
        "clear": "Clear",
        "failedToLoadHistory": "Failed to load track history",
        "tracksPlayed": "Tracks Played",
        "playTime": "Play Time",
        "topArtist": "Top Artist",
        "mostPlayed": "Most Played",
        "none": "None",
        "topTracks": "Top Tracks",
        "topArtists": "Top Artists",
        "recentTracks": "Recent Tracks",
        "showing": "Showing {{count}} of {{total}}",
        "noTracksPlayed": "No tracks played yet",
        "playMusicToSeeHistory": "Play some music to see your history here",
        "loadMore": "Load More ({{remaining}} remaining)",
        "loading": "Loading...",
        "clearConfirmTitle": "Clear track history?",
        "clearConfirmDescription": "This permanently removes the track history and stats for this server. This cannot be undone.",
        "failedToClearHistory": "Failed to clear history",
        "playedBy": "By <bold>{{user}}</bold>",
        "justNow": "Just now",
        "minutesAgo": "{{minutes}}m ago",
        "hoursAgo": "{{hours}}h ago",
        "daysAgo": "{{days}}d ago"
    },
    "twitch": {
        "selectServerToManage": "Select a server to manage Twitch notifications",
        "twitchNotifications": "Twitch Notifications",
        "notConfigured": "Not Configured",
        "notConfiguredDesc": "Twitch API is not configured on this server. Contact the server administrator to set up Twitch credentials.",
        "noNotificationsConfigured": "No Twitch notifications configured",
        "add": "Add",
        "addTwitchNotification": "Add Twitch Notification",
        "twitchUrlOrLogin": "Twitch URL or login",
        "twitchUrlPlaceholder": "Twitch URL or login (e.g. https://twitch.tv/luk)",
        "selectDiscordChannel": "Select Discord channel",
        "save": "Save",
        "cancel": "Cancel",
        "invalidTwitchInput": "Enter a valid Twitch URL or login",
        "alreadyConfigured": "This Twitch channel is already configured",
        "failedToAddNotification": "Failed to add notification",
        "failedToRemoveNotification": "Failed to remove notification",
        "removeAriaLabel": "Remove {{login}}",
        "removeConfirmTitle": "Remove notification?",
        "removeConfirmDescription": "Stop posting live alerts for {{login}} to this server?",
        "remove": "Remove",
        "failedToLoadNotifications": "Failed to load Twitch notifications",
        "failedToLoadChannels": "Failed to load Discord channels"
    },
    "batchJobs": {
        "noServerSelected": "No Server Selected",
        "selectServerToViewJobs": "Select a server to view batch jobs",
        "batchJobs": "Batch Jobs",
        "manageOperations": "Manage bulk operations on your server",
        "jobType": "Job Type",
        "status": "Status",
        "initiated": "Initiated By",
        "progress": "Progress",
        "date": "Date",
        "allStatuses": "All statuses",
        "pending": "Pending",
        "in_progress": "In Progress",
        "paused": "Paused",
        "completed": "Completed",
        "failed": "Failed",
        "cancelled": "Cancelled",
        "noBatchJobsFound": "No batch jobs found",
        "tryAdjustingFilters": "Try adjusting your filters",
        "batchJobsWillAppearHere": "Batch jobs will appear here",
        "showingToOf": "Showing {{from}} to {{to}} of {{total}}",
        "tableHeaderJob": "Job",
        "tableHeaderType": "Type",
        "tableHeaderStatus": "Status",
        "tableHeaderInitiator": "Initiated By",
        "tableHeaderProgress": "Progress",
        "tableHeaderDate": "Date",
        "jobDetails": "Job Details",
        "targetInfo": "Target Info",
        "items": "Items",
        "totalItems": "Total Items",
        "processedItems": "Processed",
        "failedItems": "Failed",
        "skippedItems": "Skipped",
        "successItems": "Successful",
        "createdAt": "Created",
        "startedAt": "Started",
        "completedAt": "Completed",
        "estimatedTime": "Estimated Time",
        "minutes": "{{count}} minutes",
        "liveProgress": "Live Progress",
        "refresh": "Refresh",
        "cancel": "Cancel",
        "cancelJob": "Cancel Job",
        "previousPage": "Previous page",
        "nextPage": "Next page",
        "cancelJobConfirmTitle": "Cancel this job?",
        "cancelJobConfirmDescription": "Items already processed will not be reverted.",
        "cancelJobConfirm": "Yes, cancel job",
        "keepJob": "Keep job",
        "cancelling": "Cancelling...",
        "jobCancelled": "Job cancelled",
        "failedToCancelJob": "Failed to cancel job",
        "failedToLoadJobs": "Failed to load batch jobs",
        "failedToLoadJobDetails": "Failed to load job details",
        "jobItemStatus": "Item Status",
        "noItemsFound": "No items found",
        "itemsWillAppearHere": "Job items will appear here"
    },
    "roleGroups": {
        "noServerSelected": "No server selected",
        "selectServerToView": "Select a server to manage its role groups.",
        "loadError": "Failed to load role groups",
        "noGroupsYet": "No role groups yet",
        "noGroupsHint": "Role groups are created from a Reaction Roles panel — open Reaction Roles, pick a panel, and choose \"Create Role Group\".",
        "linkedPanel": "Panel",
        "rolesInGroup": "Roles in this group",
        "noRolesInGroup": "No roles in this group yet — add one below.",
        "removeRole": "Remove role",
        "roleRemoved": "Role removed from group",
        "removeError": "Failed to remove role",
        "color": "Color",
        "buttonStyle": "Button style",
        "hoist": "Show separately",
        "mentionable": "Mentionable",
        "defaultEmoji": "Default emoji",
        "save": "Save",
        "saving": "Saving...",
        "saved": "Role group updated",
        "saveError": "Failed to save role group",
        "addRole": "Add styled role",
        "cancelAddRole": "Cancel"
    }
}
